import React from 'react';
import { ISvgProps } from '../svg.types';

export const LogoAffiny = ({
  width = 163,
  height = 50,
  ...rest
}: ISvgProps) => (
  <svg width={width} height={height} {...rest}>
    <defs>
      <linearGradient
        x1=".007%"
        y1="49.987%"
        x2="100.015%"
        y2="49.987%"
        id="logoGradient"
      >
        <stop stopColor="#F08168" offset="0%" />
        <stop stopColor="#E94368" offset="99%" />
      </linearGradient>
    </defs>
    <g fill="none">
      <path
        d="M81.583 21.621h-.644v2.383c-1.69-1.756-4.206-2.792-6.963-2.792-5.891 0-10.34 4.551-10.34 10.586 0 5.959 4.542 10.626 10.34 10.626 2.761 0 5.276-1.044 6.963-2.814v2.405h3.91V21.623h-3.266v-.002zM74.18 38.637c-3.722 0-6.635-3.02-6.635-6.88 0-3.79 2.913-6.76 6.635-6.76 3.277 0 6.758 2.417 6.758 6.882 0 3.854-2.907 6.758-6.76 6.758h.002zm33.105-16.807v-2.08c0-3.253 1.216-4.701 3.943-4.701h1.412v-3.685h-1.776c-4.81 0-7.457 3.078-7.457 8.669v1.8h-9.431V19.75c0-3.253 1.216-4.701 3.945-4.701h2.06v-3.685h-2.427c-4.809 0-7.458 3.078-7.458 8.669v1.8h-3.732v3.444h3.732v16.39h3.88V25.274h9.44v16.393h3.878V25.274h7.767v16.393h3.878V21.83h-11.645l-.01-.001z"
        fill="#464648"
      />
      <path
        d="M116.268 12.879c-1.477 0-2.632 1.174-2.632 2.673 0 1.45 1.181 2.63 2.632 2.63 1.5 0 2.671-1.155 2.671-2.63 0-1.523-1.149-2.673-2.671-2.673zm18.142 8.333c-1.945 0-4.2.705-5.692 2.24v-1.86H125V40.9h3.718V30.266c.09-5.005 4.2-5.391 5.462-5.391 2.706 0 4.523 2.01 4.523 5.005v11.03h3.721V29.762c-.004-5.194-3.149-8.55-8.014-8.55zm28.298.758h-3.094l-.16.372-5.702 13.417-5.631-13.414-.159-.375h-4.022l.357.844 7.421 17.578-3.643 8.766-.35.842h3.978l.158-.372 11.415-26.812.361-.846z"
        fill="#464648"
      />
      <path
        d="M44.32 17.424a8.712 8.712 0 118.71-8.71 8.72 8.72 0 01-8.71 8.71zm0-14.121a5.411 5.411 0 10-.01 10.822 5.411 5.411 0 00.01-10.822z"
        fill="#E94368"
      />
      <path
        d="M55.355 23.702c-2.42-2.157-5.832-3.247-10.148-3.247-8.144 0-14.7 5.158-16.267 6.5l1.891 1.174c2.148-1.634 8.565-3.922 14.372-3.922 3.38 0 5.963.778 7.684 2.31 1.674 1.493 2.488 3.294 2.488 5.507 0 1.94-.676 3.483-2.067 4.718-1.441 1.278-3.68 1.927-6.652 1.927-4.245 0-9.842-3.913-15.255-7.698-6.494-4.542-13.21-9.238-19.72-9.238-3.603 0-6.46.88-8.49 2.623C1.073 26.174 0 28.434 0 31.072c0 2.73 1.155 5.124 3.434 7.11 2.2 1.917 5.235 2.889 9.008 2.889 7.791 0 12.772-6.914 13.059-7.18l-1.617-1.221c-1.557 1.26-6.227 4.646-11.442 4.646-2.86 0-5.073-.665-6.577-1.976-1.444-1.26-2.146-2.654-2.146-4.268 0-1.528.598-2.754 1.882-3.854 1.338-1.148 3.384-1.731 6.08-1.731 5.348 0 11.577 4.357 17.598 8.57 6.154 4.302 11.965 8.367 17.373 8.367 3.903 0 6.968-.964 9.108-2.864 2.21-1.961 3.331-4.496 3.331-7.536.009-3.306-1.25-6.106-3.736-8.322z"
        fill="url(#logoGradient)"
      />
      <path
        d="M10.229 18.94a7.954 7.954 0 117.953-7.954 7.962 7.962 0 01-7.953 7.953zm0-12.898a4.94 4.94 0 104.94 4.94 4.946 4.946 0 00-4.94-4.936v-.004z"
        fill="#F08168"
      />
    </g>
  </svg>
);
